import React, { useState, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';


ChartJS.register(ArcElement, Tooltip, Legend);

const apiUrl = process.env.REACT_APP_API_URL;

const DemMailStatsChart = () => {
    const [chartData, setChartData] = useState(null);
    const [chartDate, setChartDate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Labels de base pour le calcul
    const baseLabels = [
        'Tentative contact',
        'Relance devis',
        'Demande d’avis'
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiUrl}IHM/api/apiMail/get_mail_stats_Dem.php`);
                const result = await response.json();

                if (result.success && result.data.length > 0) {
                    const latestStats = result.data[0];
                    setChartDate(latestStats.date_jour); 

                    const dataValues = [
                        latestStats.tentative,
                        latestStats.relance,
                        latestStats.retour,
                    ];
                    
                    const total = dataValues.reduce((acc, val) => Number(acc) + (Number(val) || 0), 0) || 1;

             
                    const formattedLabels = baseLabels.map((label, index) => {
                        const value = Number(dataValues[index] || 0);
                        const percent = ((value / total) * 100).toFixed(1);
                        return `${label}: ${value} (${percent}%)`;
                    });

                    setChartData({
                        labels: formattedLabels, 
                        datasets: [
                            {
                                label: 'Mails - dernier jour',
                                data: dataValues,
                                backgroundColor: [
                                    '#fec868',
                                    '#277da1',
                                    '#9fcd58'
                                ],
                            },
                        ],
                    });

                } else {
                    setError("Aucune donnée.");
                }
            } catch {
                setError("Erreur API");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);


    const options = {
        responsive: true,
        plugins: {
            legend: { 
                position: 'bottom',
                labels: {
                    font: {
                        weight: 'normal', 
                    },
                }
            },
           
            tooltip: {
                bodyFont: {
                    weight: 'normal'
                },
                callbacks: {
                    label: function(ctx) {
                        return ctx.label; 
                    }
                }
            }
        }
    };

    if (loading) return <p></p>;
    if (error) return <p>{error}</p>;
    if (!chartData) return <p>Aucune statistique disponible.</p>;


    return (
        <div style={{width : 250}}>
            <Doughnut data={chartData} options={options} />
        </div>
    );
};

export default DemMailStatsChart;